import { useState } from "react"
import Topics from "./topics"
import SubTopics from "./subTopics"
import QuestionOpt from "./questionOption"
import GeneratedQuestions from "./genertedQuestion"
import Lessons from "./lessons"
import QuizDetails from "./quizDetails"


function CreateAssememtWithAi() {

    const [currentStep, setCurrentStep] = useState(1)
    const initialState = {
        curriculum: '',
        curriculumName: '',
        syllabus: "",
        grade: "",
        subject: '',
        selectedLessons: [],
        selectedSubTopics: [],
        noOfQuestion: 3,
        difficulty: 'easy',
        subjectName: '',
        gradeName: ""
    }

    const [details, setDetails] = useState(initialState)

    const [topics, setTopics] = useState([])
    const [lessonsIds, setLessonsIds] = useState([])
    const [topicsIds, setTopicsIds] = useState([])

    const handleChange = (key, value) => {

        setDetails(prev => ({
            ...prev,
            [key]: value
        }))

    }

    return (

        <>
            {
                currentStep === 1 && <QuizDetails details={details} handleChange={handleChange} handleNext={setCurrentStep} />
            }
            {
                currentStep == 2 && <Lessons handleNext={setCurrentStep} details={details} handleChange={handleChange} topics={topics} setTopics={setTopics}
                    lessonsIds={lessonsIds} setLessonsIds={setLessonsIds} setTopicsIds={setTopicsIds}
                />
            }

            {
                currentStep === 3 && <SubTopics handleNext={setCurrentStep} details={details} handleChange={handleChange} topics={topics} setTopics={setTopics}
                    topicsIds={topicsIds} setTopicsIds={setTopicsIds}
                />
            }
            {
                currentStep == 4 && <QuestionOpt handleNext={setCurrentStep} details={details} handleChange={handleChange} topics={topics} setTopics={setTopics} />
            }
            {
                currentStep == 5 && <GeneratedQuestions handleNext={setCurrentStep} details={details} lessonsIds={lessonsIds} topicsIds={topicsIds}
                    setDetails={setDetails} initialState={initialState} setTopics={setTopics}
                />
            }
        </>

    )

}

export default CreateAssememtWithAi